import { render, staticRenderFns } from "./TechnicalFooter.vue?vue&type=template&id=6f5200b8"
import script from "./TechnicalFooter.vue?vue&type=script&lang=js"
export * from "./TechnicalFooter.vue?vue&type=script&lang=js"
import style0 from "./TechnicalFooter.vue?vue&type=style&index=0&id=6f5200b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports